import { memo, useMemo } from 'react';
import { BottomButton, Footer, Label } from './components/styles';
import { useTranslate } from '@tolgee/react';
import CheckboxGroup from './components/CheckboxGroup';
import { css } from '@emotion/css';
import { RegionCheckbox } from './components/RegionCheckbox';
import DepartmentItemSelect from './components/DepartmentItemSelect';
import { RightOutlined } from '@ant-design/icons';
export const regionOptions: General.UpperCaseRegion[] = ['SG', 'TH', 'MY', 'PH', 'VN', 'ID'];

interface LazadaStepBProps {
  onNext: () => void;
  storeType: string;
  setStoreType: (value: any) => void;
  region: General.UpperCaseRegion;
  setRegion: (value: any) => void;
  departments: number[];
  setDepartments: (value: number[]) => void;
}
export const LazadaStepB = memo((props: LazadaStepBProps) => {
  const { onNext, setStoreType, storeType, region, setRegion, departments, setDepartments } = props;
  const { t } = useTranslate();
  const authWayOptions = useMemo(() => {
    return [
      {
        value: 'CROSS',
        render: t('跨境店铺'),
      },
      {
        value: 'LOCAL',
        render: t('authShop.本土店铺'),
      },
    ];
  }, [t]);
  return (
    <div>
      <Label>
        <span className="font-[SimSun,sans-serif] text-[#ff4d4f]">* </span>
        {t('authShop.请选择您要添加的店铺类型')}
      </Label>
      <CheckboxGroup
        layout="horizontal"
        className={css`
          .ant-col {
            flex-basis: auto !important;
            & > div {
              width: fit-content;
              min-width: 120px !important;
              text-align: center;
            }
          }
          .anticon {
            font-size: 22px;
          }
        `}
        value={storeType}
        options={authWayOptions}
        onChange={(e) => setStoreType(e as string)}
      />

      {storeType === 'LOCAL' && (
        <>
          <Label>
            <span className="font-[SimSun,sans-serif] text-[#ff4d4f]">* </span>
            {t('authShop.请选择店铺站点')}
          </Label>
          <RegionCheckbox options={regionOptions} value={region} onChange={(e) => setRegion(e)} />
        </>
      )}

      {storeType === 'CROSS' && (
        <DepartmentItemSelect platform="lazada" value={departments} onChange={setDepartments} />
      )}
      <Footer className="mt-[90px]">
        <BottomButton
          size="large"
          type="primary"
          onClick={() => {
            onNext();
          }}
        >
          {t('authShop.下一步')}
          <RightOutlined />
        </BottomButton>
      </Footer>
    </div>
  );
});

LazadaStepB.displayName = 'LazadaStepB';
